"use client";

import IHVNavigationBarProps, {
  INavigationItem,
} from "./IHVNavigationBarProps";
import { Box } from "@mantine/core";
import { Image } from "@mantine/core";

import style from "./HVNavigationBar.module.css";
import HVTooltip from "../HVTooltip/HVTooltip";
import HVText from "../HVText/HVText";

const HVNavigationBar = ({
  menus,
  logoSrc,
  activeMenuId,
  title,
  onSelect,
  containerProps,
  logoContainerProps,
  logoImageProps,
  logoTextProps,
  onLogoClick,
}: IHVNavigationBarProps) => {
  return (
    <Box component="div" className={style.mainNavigation} {...containerProps}>
      <Box
        component="button"
        className={style.logoHeader}
        {...logoContainerProps}
        onClick={onLogoClick}
      >
        <Image src={logoSrc} alt="logo" {...logoImageProps} />
        {title && <HVText {...logoTextProps}>{title}</HVText>}
      </Box>
      {menus.map((item: INavigationItem) => {
        return (
          <HVTooltip
            label={item.title}
            isHoverEffectNeeded={false}
            position="right"
            key={item.id}
            {...item.tooltipProps}
          >
            <Box
              component="a"
              onClick={() => {
                onSelect(item.id);
              }}
              href={item.link}
              className={style.menuItem}
              aria-label={item.menuContainerAriaLabel || item.title}
              {...item.containerProps}
            >
              <Box
                component="div"
                className={style.menuIcon}
                {...item.iconContainerProps}
                aria-label={item.iconContainerAriaLabel}
              >
                {item.id === activeMenuId
                  ? (item.selectedIcon ?? item.icon)
                  : item.icon}
              </Box>
            </Box>
          </HVTooltip>
        );
      })}
    </Box>
  );
};

export default HVNavigationBar;
